/** @format */

import React, { Component } from 'react';
import { Menu, Input, Form } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import './SalesToolbar.css';

import { inject, observer } from 'mobx-react';

@inject('SalesStore', 'NotificationsStore')
@observer
class SalesToolbar extends Component {
  render() {
    let { SalesStore } = this.props;
    let AdvancedSearchActive = SalesStore.salesParams.advancedSearch.active;
    return (
      <Menu className="sales-toolbar" borderless size="small">
        <Menu.Menu position="right">
          <Menu.Item>
            <Form size="tiny" onSubmit={() => SalesStore.searchSaleDeep()}>
              <Input
                size="small"
                className="search-input"
                onChange={(e, input) => SalesStore.searchSale(input.value)}
                value={SalesStore.salesParams.searchValue}
                icon="search"
                placeholder="Cerca Vendita"
              />
            </Form>
          </Menu.Item>
          <Menu.Item onClick={SalesStore.openAdvancedSearch}>
            <small className={AdvancedSearchActive ? 'strong' : null}>
              ricerca avanzata
            </small>
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    );
  }
}

export default withRouter(SalesToolbar);
